import script from "./Cates.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cates.vue?vue&type=script&lang=ts&setup=true"

import "./Cates.vue?vue&type=style&index=0&id=08a7bd94&lang=css"

const __exports__ = script;

export default __exports__